import * as ds from '@attain-apps/fe/web/main/lib/design'
import type cytoscape from 'cytoscape'

import type * as models from '../models'

const EDGE_COLOR = ds.color.Scale.SHADOW.main
const DEFAULT_BACKGROUND_SHADES = -1
const DEFAULT_BORDER_SHADES = 0
const SELECTED_BORDER_SHADES = 2

/**
 * Returns the appropriate styles for all elements in Cytoscape, for the given
 * {@link models.OrgChart}
 *
 * @see {@link cytoscape.StylesheetJson}
 */
export function getStyles({
  orgChartId,
}: models.OrgChart.Identifier): cytoscape.StylesheetJson {
  const colorScale =
    orgChartId === 'proposed'
      ? ds.color.Scale.SECONDARY
      : ds.color.Scale.PRIMARY
  const defaultBackgroundColor = colorScale.shadeFromMain(
    DEFAULT_BACKGROUND_SHADES,
  )
  const defaultBorderColor = colorScale.shadeFromMain(DEFAULT_BORDER_SHADES)
  const selectedBorderColor = colorScale.shadeFromMain(SELECTED_BORDER_SHADES)
  const temporaryBackgroundColor = colorScale.lightest
  const temporaryBorderColor = defaultBorderColor
  const temporaryFontColor = temporaryBorderColor
  const futureBackgroundColor = colorScale.lightest
  const futureBorderColor = defaultBorderColor
  const futureFontColor = futureBorderColor
  // Styles for all org charts
  const styles: cytoscape.StylesheetJson = [
    {
      selector: 'node',
      style: {
        'background-color': defaultBackgroundColor,
        'border-color': defaultBorderColor,
        'border-width': 2,
        color: 'white',
        'font-size': '12px',
        height: '60px',
        label: (cyNode: cytoscape.NodeSingular) => {
          const node: models.Node = cyNode.data()
          let label = node.name
          if (node.person) {
            label += `\n\n${node.person}`
          }
          return label
        },
        shape: 'roundrectangle',
        'text-halign': 'center',
        'text-max-width': '110px',
        'text-valign': 'center',
        'text-wrap': 'wrap',
        width: '120px',
      },
    },
    {
      selector: 'node.temporary',
      style: {
        'background-color': temporaryBackgroundColor,
        'border-color': temporaryBorderColor,
        'border-style': 'dashed',
        color: temporaryFontColor,
      },
    },
    {
      selector: 'node.future',
      style: {
        'background-color': futureBackgroundColor,
        'border-color': futureBorderColor,
        color: futureFontColor,
      },
    },
    {
      selector: 'node:selected',
      style: {
        'border-color': selectedBorderColor,
        'border-width': '4px',
      },
    },
    {
      selector: 'edge',
      style: {
        'curve-style': 'bezier',
        'line-color': EDGE_COLOR,
        'target-arrow-color': EDGE_COLOR,
        'target-arrow-shape': 'triangle',
        width: 2,
      },
    },
  ]
  if (orgChartId === 'proposed') {
    // Styles specific to 'proposed' org chart
    styles.push(
      {
        selector: 'node',
        style: {
          opacity: 0.5,
        },
      },
      {
        selector: 'node.changed',
        style: {
          opacity: 1,
        },
      },
    )
  }
  return styles
}
